$(".slick-slider").slick({
  slidesToShow: 1,
  infinite:false,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  autoplaySpeed: 2000,
   responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        infinite: true,
      }
    }
  ]
});

$('.slick-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    var totalSlides = slick.slideCount;
    $('.slick-dots li button').each(function(index) {
        $(this).text((index + 1).toString().padStart(2, '0'));
    });
});



// Collection Slider
$(document).ready(function() {
  function checkWidth() {
    if ($(window).width() <= 767) {
      if (!$('.seller-collection-slider').hasClass('slick-initialized')) {
        $('.seller-collection-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          autoplay: true,
          speed: 300
        });
      }
    } else {
      if ($('.seller-collection-slider').hasClass('slick-initialized')) {
        $('.seller-collection-slider').slick('unslick');
      }
    }
  }

  checkWidth(); // Check width on page load
  $(window).resize(checkWidth); // Check width on window resize
});






// Lightbox Code
$(document).ready(function() {
    $('.play-button').on('click', function() {
        var lightbox = $(this).closest('.product-img').find('.video-lightbox').css('display', 'flex').hide().fadeIn();
        $('body').addClass('lightbox-active');
        lightbox.find('.lightbox-video')[0].play();
    });

    $('.close, .video-lightbox').on('click', function(e) {
        if ($(e.target).is('.close, .video-lightbox')) {
            var lightbox = $(this).closest('.video-lightbox');
            var video = lightbox.find('.lightbox-video')[0];
            lightbox.fadeOut().css('display', 'none');
            $('body').removeClass('lightbox-active');
            video.pause(); video.currentTime = 0;
        }
    });
});


// COLLECTION VIDEO CODE

$(document).ready(function() {
    var video = $("#myVideo").get(0);

    // Handle play button click
    $(".play-button-video").click(function() {
        video.play();        // Start the video
        $(this).hide();      // Hide the play button
    });

    // Show play button when the video is paused
    $("#myVideo").on("pause", function() {
        $(".play-button-video").show();  // Show the play button when paused
    });

    // Hide play button when the video is playing
    $("#myVideo").on("play", function() {
        $(".play-button-video").hide();  // Hide the play button when playing
    });
});



// SAME--HEIGHT--JQUERY
window.onload = function() {
    // Check if viewport width is above 767 pixels
    if (window.innerWidth > 0) {
        // Equalize heights of divs with class 'equal-height-div'
        equalizeHeights('.product-inner-cont h3');


    }
};

function equalizeHeights(className) {
    // Get all elements with the specified class name
    var divs = document.querySelectorAll(className);

    // Initialize variable to hold maximum height
    var maxHeight = 0;

    // Loop through each div to find the maximum height
    divs.forEach(function(div) {
        var divHeight = div.clientHeight;
        maxHeight = Math.max(maxHeight, divHeight);
    });

    // Set the height of all divs to the maximum height
    divs.forEach(function(div) {
        div.style.height = maxHeight + 'px';
    });
}